<template>
  <div class="quad-viz-pure">
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>AB = AC ⇔ ∠B = ∠C$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="280" viewBox="0 0 500 280">
          <g transform="translate(250, 50)">
            <path d="M 0 0 L -80 180 L 80 180 Z" fill="rgba(0, 210, 255, 0.1)" stroke="#00d2ff" stroke-width="3" />
            
            <!-- Angle Arcs -->
            <path d="M -50 180 A 30 30 0 0 0 -58 155" fill="none" stroke="#ffd700" stroke-width="2" />
            <path d="M 50 180 A 30 30 0 0 1 58 155" fill="none" stroke="#ffd700" stroke-width="2" />
            
            <!-- Equal side markers -->
            <path d="M -45 85 l 10 10" stroke="#00d2ff" stroke-width="2" />
            <path d="M 35 85 l 10 10" stroke="#00d2ff" stroke-width="2" />

            <!-- Symmetry axis (Three lines in one) -->
            <line x1="0" y1="0" x2="0" y2="180" stroke="#ff4757" stroke-width="2" stroke-dasharray="5,3" />
            <text x="5" y="100" fill="#ff4757" font-size="10">中线/高/角平分线</text>
          </g>
        </svg>
      </div>

      <div class="bottom-controls">
        <div class="discovery-note" v-latex>
          <p><strong>等腰三角形性质：</strong>两腰相等，则对应的两个底角也相等（等边对等角）。<strong>“三线合一”</strong>是指顶角平分线、底边中线和底边高线重合。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IsoscelesTriangleViz',
  props: { knowledgePoint: { type: String, default: '' } }
}
</script>

<style scoped lang="scss">
.quad-viz-pure { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #010205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>